import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Form } from 'react-final-form';

import BodyForm from './BodyForm';
import DetailTable from './DetailTable/DetailTable';
import dayjs from 'dayjs';

const IssueForm = ({
    issueData,
    onSubmit,
    update,
    path_back,
    isViewed,
    issues,
    setIssues,
    onClick,
}) => {
    // variable to handle allowing to edit supplier, date and location fields if there is already a product added
    const inputEditabel = issues.length >= 1;
    if (isViewed) {
        const { details } = issueData;
        if (details) {
            // so that it runs only once
            useEffect(() => {
                // data for table
                details.map((issue) => {
                    issue.description = issue.product.description;
                    issue.school_kit = issue.school_kit;
                    issue.school_kit_name = issue.school_kit
                        ? issue.school_kit.name
                        : '';
                });
                // Assign the kit data to the table
                const current_issue = issueData.details;
                setIssues(...issues, current_issue);
            }, []);
        }
    }
    return (
        <React.Fragment>
            <Form
                onSubmit={onSubmit}
                initialValues={issueData}
                mutators={{
                    // expect (field, value) args from the mutator
                    setValue: ([field, value], state, { changeValue }) => {
                        changeValue(state, field, () => value);
                    },
                }}
                render={({ handleSubmit, submitting, form, values }) => {
                    if (!window.setFormIssue)
                        window.setFormIssue = form.mutators.setValue;
                    if (_.get(values, 'date', undefined) === undefined) {
                        form.change('date', dayjs());
                    }
                    return (
                        <form
                            onSubmit={handleSubmit}
                            className="form-validate mb-lg"
                        >
                            {!isViewed && (
                                <BodyForm inputEditabel={inputEditabel} />
                            )}
                            <DetailTable
                                issueData={issueData}
                                isViewed={isViewed}
                                issues={issues}
                                setIssues={setIssues}
                            />

                            <div className="d-flex flex-column-reverse flex-md-row justify-content-between my-5">
                                <Link
                                    to={path_back}
                                    className="btn btn-secondary mt-4 mt-md-0"
                                >
                                    Regresar
                                </Link>
                                {!isViewed && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={submitting}
                                        onClick={onClick}
                                    >
                                        {update ? 'Actualizar' : 'Guardar'}
                                    </button>
                                )}
                            </div>
                        </form>
                    );
                }}
            />
        </React.Fragment>
    );
};

export default IssueForm;
